<template>
  <a-card :bordered="false">
    <app-warp title='小程序模板'>
      <template #app-content>
        <div class="app-module" data-module='search' draggable>
        </div>
      </template>
      <template #app-sider>
        <a-form :model="form" ref='ruleForm' :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button  @click="$router.go(-1)" class='m-r-20'  > 返回 </a-button>
            <a-button type="primary" @click="onSubmit"> 保存 </a-button>
          </a-form-item>
        </a-form>
      </template>
    </app-warp>
  </a-card>
</template>
<script>
import { reactive, toRef, toRefs, watch, watchEffect, ref, inject } from "vue";
import { setMemberVip,getMemberVipDetail,editMemberVip,delMemberVip } from "@/api/member";
import { message, Modal } from "ant-design-vue";
import { iscode } from "@/utils/app";
export default {
  setup(props) {
    const state = reactive({
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      form: {
       
      },
    });
    const setOldMap = ref();
    const handleChoose = (data) => {
      state.form.background_map = `url(${data}) `;
      state.form.background = data;
    };
    const $router=inject('$router')
    const $route=inject('$route')
    if($route.query.id){
      getMemberVipDetail($route.query.id).then(res=>{
        state.form=res.data.data
      }).catch(error=>error)

    }
    // 保存
    const ruleForm = ref();
    const onSubmit = () => {
      ruleForm.value.validate().then(async (e) => {
          var background_map=state.form.background_map;
          if (state.form.is_upload == 1) {
            if (!state.form.background) {
              message.error("请选择背景图");
              return;
            } else {
              background_map = state.form.background;
            }
          }
          let result;
          if($route.query.id){
           result = await editMemberVip($route.query.id,{ ...state.form,background_map: background_map,}).then((res) => res.data).catch((error) => error);
          }else{
           result = await setMemberVip({ ...state.form,background_map: background_map,}).then((res) => res.data).catch((error) => error);
          }
          if (iscode(result, true)) {
                $router.go(-1)
          }
        }).catch((error) => {});
    };
    return {
      ...toRefs(state),
      handleChoose,
      ruleForm,
      onSubmit,
    };
  },
};
</script>
<style lang="less" scoped>
@import url("@/style/app-warp/app-warp.less");
.ant-checkbox-wrapper {
  width: 500px;
}
.normal_map {
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      margin-right: 10px;
      margin-bottom: 10px;
      // background: url(https://zx-oss.hebeigaoda.com/ydd_resource/20201113/e6933b585fea645a0180f2f24ed95c50.png)  ;
      label {
        width: 57px;
        height: 57px;
        display: block;
        border: 1px solid transparent;
      }
      input:checked ~ label {
        border: 1px solid #05486A;
      }
    }
  }
}
</style>